import {
  authConfigSnapshot,
  authStoreSnapshot,
  authUserSnapshot,
  updateAuthUser,
} from '../repositories/auth.repository';
import { tapResult } from '@ngneat/effects';
import { AuthwsApi } from '@tmx/data-access';

/**
 * Use this to allow the User to accept the Terms of Service. This function will internally update
 * the current User's `currentTermsAccepted` property. This makes it safe to attempt to redirect the
 * User back to your main application Route.
 *
 * @param termsVersion Version number for the Terms of Service
 * @returns Observable that completes when the User has accepted the terms
 */
export const acceptTerms = (termsVersion: number) => {
  if (termsVersion < 1) {
    throw new Error('Terms of Service version must be at least 1');
  }

  if (authStoreSnapshot().authState.state !== 'authenticated') {
    throw new Error('User needs to be authenticated');
  }

  const user = authUserSnapshot();

  return AuthwsApi.postProductAccountUserTerms(
    authConfigSnapshot().trimbleIdentity.trimbleMapsAppName,
    user.accountId,
    termsVersion
  ).pipe(
    tapResult(() => {
      updateAuthUser({
        ...user,
        currentTermsAccepted: true,
      });
    })
  );
};
